// @flow
const ActionTypes = {
  INIT: 'app/init',
  IS_LOADING: 'IS_LOADING',
  HAS_ERROR: 'HAS_ERROR',
  PERSIST_STORE: 'app/persistStore',
  IS_CUSTOMER_TYPE: 'isCustomerType',
  SET_BRAND_NAME: 'SET_BRAND_NAME',
  SET_MSISDN: 'SET_MSISDN',
  SET_EID: 'SET_EID',
  SET_TOGGLES: 'SET_TOGGLES',
  FETCH_TOGGLES: 'FETCH_TOGGLES',
  FETCH_CUSTOMER_TYPE: 'FETCH_CUSTOMER_TYPE',
  FETCH_APP_CONTENT_START: 'FETCH_APP_CONTENT',
  FETCH_APP_CONTENT_COMPLETE: 'FETCH_APP_CONTENT_COMPLETE',
};

export const init = () => ({
  type: ActionTypes.INIT,
});

export const loadingAction = (payload = false) => ({
  type: ActionTypes.IS_LOADING,
  payload,
});

export const errorMessage = (payload) => ({
  type: ActionTypes.HAS_ERROR,
  payload,
});

export const persistStore = () => ({
  type: ActionTypes.PERSIST_STORE,
});

export const isCustomerType = ({ customerType, customerTypeContentKey }) => {
  return {
    type: ActionTypes.IS_CUSTOMER_TYPE,
    customerType,
    customerTypeContentKey,
  };
};

export const setMsisdn = (msisdn) => {
  return {
    type: ActionTypes.SET_MSISDN,
    msisdn,
  };
};

export const setEid = (eid) => {
  return {
    type: ActionTypes.SET_EID,
    eid,
  };
};

export const fetchToggles = (toggles) => {
  return {
    type: ActionTypes.FETCH_TOGGLES,
    toggles,
  };
};

export const setToggles = (toggles, togglesNew) => {
  return {
    type: ActionTypes.SET_TOGGLES,
    toggles,
    togglesNew,
  };
};

export const fetchCustomerType = ({ imsi, msisdn }) => {
  return {
    type: ActionTypes.FETCH_CUSTOMER_TYPE,
    imsi,
    msisdn,
  };
};

export const fetchApplicationContent = () => {
  return {
    type: ActionTypes.FETCH_APP_CONTENT_START,
  };
};

export const fetchApplicationcontentComplete = (data) => {
  return {
    type: ActionTypes.FETCH_APP_CONTENT_COMPLETE,
    data,
  };
};

export default ActionTypes;
